import React from "react";
import HomeNavbar from "./HomeNavbar";
import FloatText from "./FloatText";

const Header = () => {
  return (
    <div className="flex flex-col relative justify-center">
      <div className="flex relative">

        <img src={"/prjimg/RagonInstituteII/ragon_edit.webp"} />
        

      </div>
      <div className="w-full flex flex-col absolute top-0">
        <HomeNavbar absolute={true} color="white" />
      </div>
      <div className="flex absolute w-full">
          <FloatText />
        </div>
    </div>
  );
};

export default Header;
